import type { IconData } from '@stacksjs/iconify-core'

export const keySkeleton: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M7 12a5 5 0 1 0 0 10a5 5 0 0 0 0-10m-1.415 7.413a1 1 0 1 1 0-2a1 1 0 0 1 0 2\" opacity=\".5\"/><path fill=\"currentColor\" d=\"m21.001 4.413l.706-.706a1 1 0 1 0-1.414-1.414L9.754 12.832a5 5 0 0 1 1.414 1.414l5.591-5.591l2.12 2.12a1 1 0 0 0 1.414-1.414l-2.12-2.12l1.414-1.414l.706.705a1 1 0 0 0 1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default keySkeleton
